import queryString from 'query-string'

import { axiosInstance } from './base'
import { snakeToCamelKeys } from '@/utils/object'

import constants from '~/constants.json'
import config from '../../config.json'

/**
 * Saves the given answer for the given homework element session/question combination.
 *
 * @param {number} questionId
 * @param {number|string|null}answer
 * @param {number} lapsedTime
 * @param {number} homeworkElementSessionId
 * @returns {Promise}
 */
export function saveAnswer(
  questionId,
  answer,
  lapsedTime,
  homeworkElementSessionId
) {
  const query = {
    'data[question_id]': questionId,
    'data[answer]': answer,
    'data[lapsedTime]': lapsedTime,
    'data[HomeworkElementSession][id]': homeworkElementSessionId,
  }

  return axiosInstance
    .post(
      `${constants.baseUrl}/homework/save_answer`,
      queryString.stringify(query)
    )
    .then(({ data }) => {
      return {
        ...data['question'],
        ...data['saved'],
      }
    })
}

/**
 * Returns homework details for the given homework ID.
 *
 * @param {number} homeworkId
 * @return {Promise<AxiosResponse<any>>}
 */
export function getHomeworkDetails(homeworkId) {
  return axiosInstance
    .get(`${config.apiUrl}/homework/load/?id=${homeworkId}`)
    .then(({ data }) => snakeToCamelKeys(data, true))
}
